import { render, staticRenderFns } from "./DeactivatedAutomation.vue?vue&type=template&id=0841e69d&"
import script from "./DeactivatedAutomation.vue?vue&type=script&lang=js&"
export * from "./DeactivatedAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports